 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLINTRO from '@/components/xhtml/intro'
 import XHTMLPART1 from '@/components/xhtml/part1'
 import XHTMLCH1 from '@/components/xhtml/ch1'
 import XHTMLCH2 from '@/components/xhtml/ch2'
 import XHTMLCH3 from '@/components/xhtml/ch3'
 import XHTMLPART2 from '@/components/xhtml/part2'
 import XHTMLCH4 from '@/components/xhtml/ch4'
 import XHTMLCH5 from '@/components/xhtml/ch5'
 import XHTMLCH6 from '@/components/xhtml/ch6'
 import XHTMLCH7 from '@/components/xhtml/ch7'
 import XHTMLCH8 from '@/components/xhtml/ch8'
 import XHTMLCH9 from '@/components/xhtml/ch9'
 import XHTMLPART3 from '@/components/xhtml/part3'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLCH16 from '@/components/xhtml/ch16'
 import XHTMLCH17 from '@/components/xhtml/ch17'
 import XHTMLCH18 from '@/components/xhtml/ch18'
 import XHTMLPART4 from '@/components/xhtml/part4'
 import XHTMLCH19 from '@/components/xhtml/ch19'
 import XHTMLCH20 from '@/components/xhtml/ch20'
 import XHTMLCH21 from '@/components/xhtml/ch21'
 import XHTMLCH22 from '@/components/xhtml/ch22'
 import XHTMLCH23 from '@/components/xhtml/ch23'
 import XHTMLCH24 from '@/components/xhtml/ch24'
 import XHTMLCH25 from '@/components/xhtml/ch25'
 import XHTMLCH26 from '@/components/xhtml/ch26'
 import XHTMLCH27 from '@/components/xhtml/ch27'
 import XHTMLPART5 from '@/components/xhtml/part5'
 import XHTMLCH28 from '@/components/xhtml/ch28'
 import XHTMLCH29 from '@/components/xhtml/ch29'
 import XHTMLCH30 from '@/components/xhtml/ch30'
 import XHTMLCH31 from '@/components/xhtml/ch31'
 import XHTMLCH32 from '@/components/xhtml/ch32'
 import XHTMLCH33 from '@/components/xhtml/ch33'
 import XHTMLPART6 from '@/components/xhtml/part6'
 import XHTMLCH34 from '@/components/xhtml/ch34'
 import XHTMLCH35 from '@/components/xhtml/ch35'
 import XHTMLCH36 from '@/components/xhtml/ch36'
 import XHTMLCH37 from '@/components/xhtml/ch37'
 import XHTMLCH38 from '@/components/xhtml/ch38'
 import XHTMLPART7 from '@/components/xhtml/part7'
 import XHTMLCH39 from '@/components/xhtml/ch39'
 import XHTMLCH40 from '@/components/xhtml/ch40'
 import XHTMLCH41 from '@/components/xhtml/ch41'
 import XHTMLCH42 from '@/components/xhtml/ch42'
 import XHTMLCH43 from '@/components/xhtml/ch43'
 import XHTMLCH44 from '@/components/xhtml/ch44'
 import XHTMLCH45 from '@/components/xhtml/ch45'
 import XHTMLCH46 from '@/components/xhtml/ch46'
 import XHTMLCONCL from '@/components/xhtml/concl'
 import XHTMLGUIDE from '@/components/xhtml/guide'
 import XHTMLRESOURCES from '@/components/xhtml/resources'
 import XHTMLAPP01 from '@/components/xhtml/app01'
 import XHTMLJOHN from '@/components/xhtml/john'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLBACK from '@/components/xhtml/back'
 import XHTMLBACK1 from '@/components/xhtml/back1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/intro",
 			"name" : "xhtml/intro",
 			"component" : XHTMLINTRO
 		},
 		{
 			"path" : "/xhtml/part1",
 			"name" : "xhtml/part1",
 			"component" : XHTMLPART1
 		},
 		{
 			"path" : "/xhtml/ch1",
 			"name" : "xhtml/ch1",
 			"component" : XHTMLCH1
 		},
 		{
 			"path" : "/xhtml/ch2",
 			"name" : "xhtml/ch2",
 			"component" : XHTMLCH2
 		},
 		{
 			"path" : "/xhtml/ch3",
 			"name" : "xhtml/ch3",
 			"component" : XHTMLCH3
 		},
 		{
 			"path" : "/xhtml/part2",
 			"name" : "xhtml/part2",
 			"component" : XHTMLPART2
 		},
 		{
 			"path" : "/xhtml/ch4",
 			"name" : "xhtml/ch4",
 			"component" : XHTMLCH4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js